import { ComponentType, SVGProps } from 'react'
import {
	MarketIcon,
	MavBotsIcon,
	NewsIcon,
	NavigatorIcon,
	PulseIcon,
	NexusIcon,
	SifterIcon,
	TrendingIcon,
	HerdPowerIcon,
	EyeIcon
} from 'assets/icons/icons'

export type SearchItemType = 'Navigate' | 'Bot' | 'Stock'

export interface SearchableItem {
	id: string
	icon: ComponentType<SVGProps<SVGSVGElement>>
	label: string
	keywords?: string[]
	type: SearchItemType
	to?: string
}

export const searchableItems: SearchableItem[] = [
	// Main navigation items
	{
		id: 'mavbots-arena',
		icon: MavBotsIcon,
		label: 'MavBots Arena',
		keywords: ['home', 'main', 'bots', 'MavbotsArena'],
		type: 'Navigate',
		to: '/mavbots-arena'
	},
	{
		id: 'state-of-market',
		icon: MarketIcon,
		label: 'State of Market',
		keywords: ['market', 'macro', 'sp500'],
		type: 'Navigate',
		to: '/state-of-market'
	},
	{
		id: 'news',
		icon: NewsIcon,
		label: 'News',
		keywords: ['updates', 'articles', 'breaking news', 'global news', 'Spotlight'],
		type: 'Navigate',
		to: '/news'
	},
	{
		id: 'nexus',
		icon: NexusIcon,
		label: 'Nexus',
		keywords: ['chat', 'hub', 'general chat', 'messages'],
		type: 'Navigate',
		to: '/nexus'
	},
	{
		id: 'watchlist',
		icon: EyeIcon,
		label: 'Watchlist',
		keywords: ['watchlist'],
		type: 'Navigate',
		to: '/watchlist'
	},

	// Decoder items
	{
		id: 'navigator',
		icon: NavigatorIcon,
		label: 'Navigator',
		keywords: ['find', 'search', 'locate', 'decoder'],
		type: 'Navigate',
		to: '/decoder/navigator'
	},
	{
		id: 'sifter',
		icon: SifterIcon,
		label: 'Sifter',
		keywords: ['filter', 'sort', 'refine', 'decoder'],
		type: 'Navigate',
		to: '/decoder/sifter'
	},

	// Herd items
	{
		id: 'herd-pulse',
		icon: PulseIcon,
		label: 'Herd Pulse',
		keywords: ['activity', 'trends', 'herd'],
		type: 'Navigate',
		to: '/herd/herd-pulse'
	},
	{
		id: 'trending',
		icon: TrendingIcon,
		label: 'Trending',
		keywords: ['popular', 'rising', 'hot', 'herd'],
		type: 'Navigate',
		to: '/herd/trending'
	},
	{
		id: 'herdpower',
		icon: HerdPowerIcon,
		label: 'HerdPower®',
		keywords: ['analytics', 'metrics', 'performance', 'herd'],
		type: 'Navigate',
		to: '/herd/herdpower'
	}
]
